import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { MatBottomSheetService } from 'src/app/services/mat-bottom-sheet.service';

@Component({
  selector: 'app-close-button',
  standalone: true,
  imports: [
    
  ],
  templateUrl: './close-button.component.html',
  styleUrls: ['./close-button.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CloseButtonComponent {
  private _matBottomSheetService = inject(MatBottomSheetService);
  
  public handleCloseOnClick(): void {
    this._matBottomSheetService.closeAllMatBottomSheets();  
  }
}
